import { CheckmarkCircleFilled } from "@fluentui/react-icons";
import Button from "components/Buttons/Button";
import Avatar from "components/Common/Avatar";
import React from "react";

interface IPaymentSucecssModalProps {
  onClose: () => void;
}
const PaymentSucecssModal: React.FC<IPaymentSucecssModalProps> = ({
  onClose,
}) => {
  return (
    <div className="flex flex-col h-full flex-1">
      <div className="flex-1 gap-4 flex flex-col items-center m-auto">
        <Avatar customClass={"bg-opacity-20 bg-green mx-8 "}>
          <CheckmarkCircleFilled color="green" className="m-auto w-8 h-8" />
        </Avatar>
        <div className="font-semibold text-black text-center md:text-xl">
          Payment Received
        </div>
        <div className="md:text-sm text-xs text-center">
          We've received your payment, and we're currently processing it.{" "}
          <span className="font-medium text-secondary ">
            Your plan activation will follow promptly{" "}
          </span>
          once we confirm the transaction.
        </div>
      </div>
      <div className="flex md:flex-row flex-col  w-full self-center justify-center no-scrollbar">
        <Button label={"Okay"} onClick={onClose} variant="primary" />
      </div>
    </div>
  );
};

export default PaymentSucecssModal;
